import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcRulesLarge = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 45,
	height: 36,
	viewBox: "0 0 45 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.5 30.5C1.11929 30.5 0 29.3807 0 28C0 26.6193 1.11929 25.5 2.5 25.5H7.5L15 18L7.5 10.5H2.5C1.125 10.5 0 9.38113 0 8.00306C0 6.625 1.125 5.5 2.5 5.5H10L20 15.5L30 5.5H35V0.5L45 8.00306L35 15.5V10.5H32.5L25 18L32.5 25.5H35V20.5L45 28L35 35.5V30.5H30L20 20.5L10 30.5H2.5Z",
		fill: "#03A65B"
	})]
});
const ForwardRef = forwardRef(SvgIcRulesLarge);
export default ForwardRef;
